// extracted by css-extract-rspack-plugin
export default {"cls1":"UserCard-cls1_qhO","cls2":"UserCard-cls2_KOa UserCard-cls1_qhO"};